import {
  B_15,
  BANNER_DEFAULTS,
  hideB15Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

import defaultLogoImage from "@stadium/shared/src/assets/images/plasmic-static-slices/header-logo.svg";
import stadiumLogo from "@stadium/shared/src/assets/images/stadium-logo.svg";

export const B15_PLASMIC_PROPS = {
  b15Image: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_15].image,
    description: "Main image (B15 only)",
    hidden: hideB15Props,
  },
  b15ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_15].imageAlt,
    description: "Main image alt text (B15 only)",
    hidden: hideB15Props,
  },
  b15LogoImage: {
    type: "imageUrl",
    defaultValue: defaultLogoImage,
    description: "Logo image (B15 only)",
    hidden: hideB15Props,
  },
  b15LogoImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_15].logoImageAlt,
    description: "Logo image alt text (B15 only)",
    hidden: hideB15Props,
  },
  b15PoweredByImage: {
    type: "imageUrl",
    defaultValue: stadiumLogo,
    description: "Powered by image (B15 only)",
    hidden: hideB15Props,
  },
  b15PoweredByImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_15].poweredByImageAlt,
    description: "Powered by image alt text (B15 only)",
    hidden: hideB15Props,
  },
  b15Subtext: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_15].subtext,
    description: "Subtext (B15 only)",
    hidden: hideB15Props,
  },
  b15InputPlaceholder: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_15].inputPlaceholder,
    description: "Input placeholder text (B15 only)",
    hidden: hideB15Props,
  },
};
